import { IRoute } from "src/pages/Router/routes";

import CreateCustomerUserPage from "./CreateCustomerUserPage";
import CustomerUserDropAssignmentPage from "./CustomerUserDropAssignmentPage";
import EditCustomerUserPage from "./EditCustomerUserPage";

const CreateCustomerUserRoutes: IRoute[] = [
  {
    exact: true,
    path: "/admin/customers/:customerId/users/create",
    pageComponent: CreateCustomerUserPage,
    title: "Create %USER%",
    menuType: "EMPTY",
    privateRoute: true,
    allowedContexts: [ "CREATE_EDIT_CUSTOMER", "CREATE_EDIT_DROP" ],
    context: "CREATE_EDIT_CUSTOMER_USER",
    permissions: [ "create-user" ]
  }
];

const EditCustomerUserRoutes: IRoute[] = [
  {
    exact: true,
    path: "/admin/customers/:customerId/users/:userId/details",
    pageComponent: EditCustomerUserPage,
    title: "Edit %USER%",
    menuType: "EDIT_CUSTOMER_USER",
    privateRoute: true,
    allowedContexts: [ "CREATE_EDIT_CUSTOMER", "CREATE_EDIT_DROP" ],
    context: "CREATE_EDIT_CUSTOMER_USER",
    permissions: [ "amend-user" ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/users/:userId/drops",
    pageComponent: CustomerUserDropAssignmentPage,
    title: "Assign %USER% %DROPS%",
    menuType: "EDIT_CUSTOMER_USER",
    privateRoute: true,
    allowedContexts: [ "CREATE_EDIT_CUSTOMER" ],
    context: "CREATE_EDIT_CUSTOMER_USER",
    permissions: [ "amend-user" ]
  }
];

export default [ ...CreateCustomerUserRoutes, ...EditCustomerUserRoutes ];
